var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('img',{staticClass:"error-image",attrs:{"alt":_vm.title,"src":_vm.imageSource}}),_c('h1',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"error-desc"},[_vm._v(" "+_vm._s(_vm.description)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }